class RAMQVulnerabilityCodeOption {
    constructor(code: number, name: string, official: string) {
        this.code = code;
        this.codeString = code.toString();
        this.name = name;
        this.official = official;
    }

    public code: number;
    public codeString: string;
    public name: string;
    public official: string;

    public static GetRAMQVulnerabilityCodeOptions(): RAMQVulnerabilityCodeOption[] {
        // current as of 2019-12-16
        // per RAMQ change notice dated 2017-09-15: http://www.ramq.gouv.qc.ca/SiteCollectionDocuments/professionnels/infolettres/2017/info171-7.pdf
        return [
            {
                code: 1,
                name: "01 - Problèmes de santé mentale chroniques et récidivants (DSM-V)",
                official: "Problèmes de santé mentale chroniques et récidivants (DSM-V) : troubles d’anxiété généralisée, troubles du comportement alimentaire (anorexie, boulimie)"
            },
            {
                code: 2,
                name: "02 - Maladies pulmonaires obstructives chroniques (MPOC), asthme de modéré à sévère, pneumopathies professionnelles",
                official: "Maladies pulmonaires obstructives chroniques (MPOC), asthme de modéré à sévère (patient présentant un vems inférieur à 70 % de la valeur prédite), pneumopathies professionnelles"
            },
            {
                code: 3,
                name: "03 - Maladie cardiaque artério-sclérotique (MCAS), insuffisance cardiaque, hypertension sévère (grade 3)",
                official: "Maladie cardiaque artério-sclérotique (MCAS), insuffisance cardiaque, hypertension sévère (grade 3)"
            },
            {
                code: 4,
                name: "04 - Cancer",
                official: "Cancer associé à un traitement passé, présent ou projeté en chimiothérapie systémique ou radiothérapie ou en phase palliative"
            },
            {
                code: 5,
                name: "05 - Diabète avec hémoglobine A1C à 6,5 ou plus au moment du diagnostic excluant le diabète de grossesse",
                official: "Diabète avec hémoglobine A1C à 6,5 ou plus au moment du diagnostic excluant le diabète de grossesse"
            },
            {
                code: 6,
                name: "06 - Toxicomanie ou alcoolisme",
                official: "Toxicomanie ou alcoolisme en cours de sevrage ou ayant donné lieu à une cure de désintoxication de drogues dures ou d’alcool au cours des cinq dernières années, toxicomanie sous traitement de méthadone ou de buprénorphine"
            },
            {
                code: 7,
                name: "07 - VIH/SIDA, hépatite C",
                official: "VIH/SIDA, hépatite C"
            },
            {
                code: 8,
                name: "08 - Maladies dégénératives du système nerveux, démence avec MMSE ≤ 26, blessés médullaires ou traumatismes crâniens avec séquelles permanentes entraînant une invalidité",
                official: "Maladies dégénératives du système nerveux, démence avec MMSE de 26 et moins, blessés médullaires avec séquelles permanentes entraînant une invalidité et des traumatismes crâniens avec séquelles permanentes entraînant une invalidité"
            },
            {
                code: 9,
                name: "09 - Maladies inflammatoires chroniques",
                official: "Maladies inflammatoires chroniques : polyarthrite rhumatoïde, psoriasis avec atteinte autre que cutanée, lupus, sclérodermie et autres collagénoses, colite ulcéreuse, maladie de Crohn"
            },
            {
                code: 10,
                name: "10 - Troubles dépressifs majeurs aigus, premier épisode ou troubles anxieux aigus, premier épisode; renouvelable tous les 24 mois",
                official: "Troubles dépressifs majeurs aigus, premier épisode ou troubles anxieux aigus, premier épisode; À partir du 1er juillet 2017, renouvelable tous les 24 mois"
            },
            {
                code: 11,
                name: "11 - Troubles dépressifs majeurs récidivants",
                official: "Troubles dépressifs majeurs récidivants"
            },
            {
                code: 12,
                name: "12 - Insuffisance rénale chronique (clairance de la créatine < 30 ml/min), insuffisance hépatique",
                official: "Insuffisance rénale chronique avec une clairance de la créatine, inférieure à 30 ml par minute, insuffisance hépatique"
            },
            {
                code: 13,
                name: "13 - Maladies thrombogènes nécessitant une anticoagulation à vie, fibrillation auriculaire avec CHADS à 2 et plus",
                official: "Maladies thrombogènes nécessitant une anticoagulation à vie, fibrillation auriculaire avec CHADS à 2 et plus"
            },
            {
                code: 14,
                name: "14 - (OBSOLÈTE) Fibrillation auriculaire nécessitant une anticoagulothérapie à vie et suivi par RIN",
                official: "Fibrillation auriculaire nécessitant une anticoagulothérapie à vie et suivi par RIN; Date de fin : 30 juin 2019"
            },
            {
                code: 15,
                name: "15 - Troubles de déficit de l'attention avec ou sans hyperactivité pour les patients âgés de moins de 18 ans",
                official: "Troubles de déficit de l’attention avec ou sans hyperactivité pour les patients âgés de moins de 18 ans"
            },
            {
                code: 16,
                name: "16 - Déficience intellectuelle pour les patients présentant des troubles importants d'expression et de compréhension",
                official: "Déficience intellectuelle pour les patients présentant des troubles importants d’expression et de compréhension"
            },
            {
                code: 17,
                name: "17 - Déficience auditive ou visuelle",
                official: "Déficience auditive lorsque la communication avec le patient se fait de façon gestuelle ou par écrit et déficience visuelle nécessitant la présence d’un accompagnateur lors de la rencontre du patient avec le médecin"
            },
            {
                code: 18,
                name: "18 - Douleur chronique qui persiste depuis plus de 6 mois",
                official: "Douleur chronique qui persiste depuis plus de six (6) mois liée à une condition chronique et provoquant une incapacité fonctionnelle ou nécessitant la prise continue d’une médication sur ordonnance lui permettant d’être fonctionnel"
            },
            {
                code: 19,
                name: "19 - Accident vasculaire cérébral",
                official: "Accident vasculaire cérébral entraînant des troubles graves de mobilité, de comportement, d’expression ou de compréhension"
            },
            {
                code: 20,
                name: "20 - Problèmes de santé mentale (DSM-IV)",
                official: "Problèmes de santé (DSM-IV) : troubles psychotiques, troubles bipolaires, troubles envahissants du développement (troubles du spectre de l’autisme, Asperger"
            }
        ].map(x => new RAMQVulnerabilityCodeOption(x.code, x.name, x.official));
    }
}

export { RAMQVulnerabilityCodeOption };
